import { ProductDetail } from '../models/product/product-details.model';
import { Vehicle } from '../models/shared/ocb';

export const isExperienceApiModel = (
  model: Partial<Vehicle> | Partial<ProductDetail>,
): model is Partial<ProductDetail> => Object.keys(model || {}).some((key) => key === 'identification');
